import type { Chat } from '@mint-sdk/api-ai-assistant';

import { useAgents } from './useAgents.jsx';

type Props = {
  isAiProcessingText: boolean;
  reasoningMessages: Chat.AiChatMessageRecordType[] | undefined;
};

export const useReasoningAgent = ({
  isAiProcessingText,
  reasoningMessages,
}: Props) => {
  const { findAgentByName } = useAgents();

  if (!isAiProcessingText) {
    return { reasoningAgent: undefined };
  }

  const firstMessage = reasoningMessages?.[0];
  const agentName = firstMessage?.message?.additionalMetadata?.agentName;

  const reasoningAgent = findAgentByName(agentName);

  return { reasoningAgent };
};
